import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "search" }
const _hoisted_2 = { class: "search__no-result" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"search__circle\"><svg width=\"109\" height=\"108\" viewBox=\"0 0 109 108\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_175_18288)\"><circle cx=\"54.5\" cy=\"54\" r=\"54\" fill=\"#E6E8ED\"></circle><path d=\"M93.0729 26.998H16.9271C14.4821 26.998 12.5 29.2366 12.5 31.998V67.998C12.5 70.7595 14.4821 72.998 16.9271 72.998H93.0729C95.5179 72.998 97.5 70.7595 97.5 67.998V31.998C97.5 29.2366 95.5179 26.998 93.0729 26.998Z\" fill=\"#FCFCFD\"></path><path d=\"M40.5 37.998H24.5C22.8431 37.998 21.5 39.3412 21.5 40.998C21.5 42.6549 22.8431 43.998 24.5 43.998H40.5C42.1569 43.998 43.5 42.6549 43.5 40.998C43.5 39.3412 42.1569 37.998 40.5 37.998Z\" fill=\"#D7DAE1\"></path><path d=\"M41.58 50.998H23.42C22.3596 50.998 21.5 52.3412 21.5 53.998C21.5 55.6549 22.3596 56.998 23.42 56.998H41.58C42.6404 56.998 43.5 55.6549 43.5 53.998C43.5 52.3412 42.6404 50.998 41.58 50.998Z\" fill=\"#D7DAE1\"></path><rect x=\"92.6812\" y=\"72.373\" width=\"42.1695\" height=\"5.38334\" rx=\"2.69167\" transform=\"rotate(45 92.6812 72.373)\" fill=\"#D7DAE1\"></rect><circle opacity=\"0.7\" cx=\"74.5195\" cy=\"58.0175\" r=\"26.0195\" fill=\"#E6E8ED\"></circle><circle cx=\"74.5195\" cy=\"58.0175\" r=\"23.5195\" stroke=\"#D7DAE1\" stroke-width=\"5\"></circle></g><defs><clipPath id=\"clip0_175_18288\"><rect x=\"0.5\" width=\"108\" height=\"108\" rx=\"54\" fill=\"white\"></rect></clipPath></defs></svg></div>", 1)
const _hoisted_4 = { class: "search__text-suggest" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Такой привилегии нет.", -1)

import { ref } from 'vue'
import FeedbackCreate from '@/components/Feedback/FeedBackCreate.vue'
import Popup from './Popup/Popup.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CardNotFound',
  setup(__props) {

const isOpen = ref(false)
const showContent = ref(false)
const openPopup = () => {
  isOpen.value = true
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, {
      name: "popup",
      onAfterEnter: _cache[3] || (_cache[3] = ($event: any) => (showContent.value = true))
    }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createBlock(Popup, {
              key: 0,
              open: isOpen.value,
              cards: false,
              feedback: true,
              showContent: showContent.value,
              onPopupClose: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false)),
              onCloseContent: _cache[2] || (_cache[2] = ($event: any) => (showContent.value = false))
            }, {
              default: _withCtx(() => [
                _createVNode(FeedbackCreate, {
                  onCloseContent: _cache[0] || (_cache[0] = ($event: any) => (showContent.value = false))
                })
              ]),
              _: 1
            }, 8, ["open", "showContent"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => (openPopup()))
          }, "Предложите идею для привилегии")
        ])
      ])
    ])
  ], 64))
}
}

})